import Repository from "./Repository";

const CREATE_NOTIFICATION = "createNotification";
const GET_ALL_NOTIFICATION = "getAllNotification";
const DELETE_NOTIFICATION = "deleteNotification";

export default {
  create_notification(payload) {
    return Repository.post(transformRoute(CREATE_NOTIFICATION), payload);
  },
  get_all_notification(payload) {
    return Repository.post(transformRoute(GET_ALL_NOTIFICATION), payload);
  },
  delete_notification(payload) {
    return Repository.post(transformRoute(DELETE_NOTIFICATION), payload);
  },
};

const transformRoute = (route) => {
  return `appservices/pushNotification/${route}`;
};
